export function getDefaultOption() {
    return {
        selectors: {
            buttons: `.generic-btn`,
        },
        classes: {
            ghostButton: `ghost-btn`,
            hide: `is-hidden`,
        }
    }
}

export function initialize(options = getDefaultOption()) {

    function activateTab(tabIndex) {
        const allTabs = document.querySelectorAll('[role="tab"]');
        const allPanels = document.querySelectorAll('[role="tabpanel"]');

        // Disattiva tutte le tab
        allTabs.forEach(tab => {
            tab.setAttribute('aria-selected', 'false');
            tab.setAttribute('tabindex', '-1');
        });

        // Nascondi tutti i panel
        allPanels.forEach(panel => {
            panel.classList.add(options.classes.hide);
        });

        // Attiva la tab corrente
        const currentTab = document.getElementById(`tab-${tabIndex}`);
        const currentPanel = document.getElementById(`tabpanel-${tabIndex}`);

        if (currentTab && currentPanel) {
            currentTab.setAttribute('aria-selected', 'true');
            currentTab.removeAttribute('tabindex');
            currentPanel.classList.remove(options.classes.hide);
        }
    }

    function initTabNavigation() {
        const allPanels = document.querySelectorAll('[role="tabpanel"]');

        allPanels.forEach((panel, index) => {
            const tabIndex = index + 1;
            const buttons = panel.querySelectorAll(options.selectors.buttons);

            buttons.forEach(button => {
                button.addEventListener('click', () => {
                    if (button.classList.contains(options.classes.ghostButton)) {
                        // Bottone "indietro" - vai alla tab precedente
                        if (tabIndex > 1) {
                            activateTab(tabIndex - 1);
                        }
                    } else {
                        // Bottone "Continua" - vai alla tab successiva
                        const totalTabs = allPanels.length;
                        if (tabIndex < totalTabs) {
                            activateTab(tabIndex + 1);
                        }
                    }
                });
            });
        });

        // Gestisci anche il click diretto sulle tab
        const allTabs = document.querySelectorAll('[role="tab"]');
        allTabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                activateTab(index + 1);
            });
        });
    }

    document.addEventListener('DOMContentLoaded', initTabNavigation);
}
